module.exports = __webpack_public_path__ + "img/ico-alarm-active.7ba8cdb7.svg";